import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminAuditLogs() {
  const [rows, setRows] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/admin/audit-logs?limit=500"); setRows(data); })(); }, []);
  return (
    <div>
      <h1 className="font-heading text-3xl font-semibold text-[var(--brand-accent)]">Audit log</h1>
      <p className="text-slate-500 mt-1">All admin actions, newest first.</p>
      <Card className="mt-5 overflow-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Time</TableHead><TableHead>Actor</TableHead><TableHead>Action</TableHead><TableHead>Target</TableHead><TableHead>Changes</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.id} data-testid={`audit-row-${r.id}`}>
                <TableCell className="text-xs text-slate-500">{new Date(r.created_at).toLocaleString()}</TableCell>
                <TableCell className="font-medium">{r.actor_email}</TableCell>
                <TableCell><span className="text-xs px-2 py-0.5 rounded bg-teal-50 text-teal-700 capitalize">{r.action.replace(/_/g, ' ')}</span></TableCell>
                <TableCell className="text-xs"><span className="font-mono">{r.target_type}{r.target_id ? `/${r.target_id.slice(0,8)}` : ""}</span></TableCell>
                <TableCell className="text-xs text-slate-600 max-w-md truncate">{r.changes && Object.keys(r.changes).length ? JSON.stringify(r.changes) : "—"}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-slate-400 py-10">No log entries</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
